import React, { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext({ lang: "id", setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("invested_lang") || "id");
  useEffect(() => {
    localStorage.setItem("invested_lang", lang);
  }, [lang]);
  const setLang = (l) => setLangState(l);
  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const t = (lang, id, en) => (lang === "id" ? id : en);
